import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoSelectOption } from '@po-ui/ng-components';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { TypeOfPerson } from 'src/app/shared/enum/type-of-person.enum';
import { LiteralsService } from 'src/app/shared/services/literals-service';
import { DOCUMENT_MASK, DOCUMENT_MASK_OF_BRA } from './constantes/document-masks';
import { ZIPCODE_MASK } from './constantes/zipcode-masks';
import { IFieldInfo } from './interface/IFieldInfo';
import { IGeneralDataInfo } from './interface/IGeneralDataInfo';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  literals: LiteralsWords;

  constructor(private literalsService: LiteralsService, private http: HttpClient) {
    this.literals = this.literalsService.getLiteralModule();
  }

  getGeneralDataByTypeOfPerson(typeOfPerson: TypeOfPerson | string, cPaisLoc: string): IGeneralDataInfo {
    return {
      documentLabel: this.getDocumentMasksByTypeOfPersonAndCountry(typeOfPerson, cPaisLoc).label || this.literals.str0703,
      documentMask: this.getDocumentMasksByTypeOfPersonAndCountry(typeOfPerson, cPaisLoc).mask || '',
      documentPlaceholder: this.getDocumentMasksByTypeOfPersonAndCountry(typeOfPerson, cPaisLoc).placeholder || '',
      documentHelp: cPaisLoc === 'BRA' ? this.literals.str0702 : '',
      nameLabel: typeOfPerson === TypeOfPerson.NATURAL ? this.literals.str0156 : this.literals.str0074,
      fantasyNameLabel: typeOfPerson === TypeOfPerson.NATURAL ? this.literals.str0157 : this.literals.str0076
    } as IGeneralDataInfo;
  }

  getDocumentMasksByTypeOfPersonAndCountry(typeOfPerson: TypeOfPerson | string, cPaisLoc: string): IFieldInfo {
    return cPaisLoc === 'BRA' ? DOCUMENT_MASK_OF_BRA[typeOfPerson]: DOCUMENT_MASK[cPaisLoc];
  }

  getZipCodeMaskByCountry(cPaisLoc: string): IFieldInfo {
    return ZIPCODE_MASK[cPaisLoc] || { placeholder: '00000-000', mask: '99999-999', minlength: 9 };
  }

  getTypePersonOptions(): PoSelectOption[] {
    return [
      {
        label: this.literals.str0670,
        value: TypeOfPerson.NATURAL
      },
      {
        label: this.literals.str0671,
        value: TypeOfPerson.LEGAL
      }
    ];
  }
}
